import {getAuthToken} from '../utility/authStorage';

/**
 * Passport token for browser-native loaders (PDF, audio, new tab).
 * Admin axios sends Authorization; direct /products/ URLs need ?access_token=
 */
export function getAdminToken() {
    return getAuthToken();
}

export function requiresMediaAccessToken(url) {
    return typeof url === 'string' && (/\/products\//i.test(url) || /\/receipts\//i.test(url));
}

export function withMediaAccessToken(url, token = getAdminToken()) {
    if (!url || typeof url !== 'string' || !token) {
        return url;
    }

    if (!requiresMediaAccessToken(url)) {
        return url;
    }

    if (/access_token=/.test(url)) {
        return url;
    }

    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}access_token=${encodeURIComponent(token)}`;
}
